import type { IconWrapperTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const iconDark: IconWrapperTheme = {
  name: 'IconWrapper',
  common: commonDark,
  self
}

export default iconDark
